import { Component, input } from '@angular/core';
import { formatPatientName } from '@insolution/core-utils';
import { Patient } from '@insolution/graphql-data-access';
import { LocalDateFormatPipe } from '@insolution/language-ui';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-personal-data',
  imports: [TranslatePipe, LocalDateFormatPipe],
  templateUrl: './personal-data.html',
  styleUrl: './personal-data.scss',
})
export class PersonalData {
  public patient = input.required<Patient>();
  public horizontalAligned = input<boolean>(false);

  protected formatPatientName = formatPatientName;
}
